import { useState, useEffect } from "react";

const KEY = "dekern-cookie-consent";
const EVT = "dekern-consent-change";

export const getConsent = () => {
  try {
    return localStorage.getItem(KEY);
  } catch {
    return null;
  }
};

export const setConsent = (value) => {
  try {
    localStorage.setItem(KEY, value);
  } catch {
    /* ignore */
  }
  window.dispatchEvent(new Event(EVT));
};

export const resetConsent = () => {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
  window.dispatchEvent(new Event(EVT));
};

export const useCookieConsent = () => {
  const [consent, setC] = useState(getConsent());
  useEffect(() => {
    const handler = () => setC(getConsent());
    window.addEventListener(EVT, handler);
    return () => window.removeEventListener(EVT, handler);
  }, []);
  return {
    consent,
    accept: () => setConsent("accepted"),
    decline: () => setConsent("declined"),
  };
};
